import Api from '@/api/index'

const state = {
  all: [],
  expired: [],
}

const getters = {}

const actions = {
  async getAll({ commit }, params) {
    const products = await Api.Product.getAll(params)
    if (products !== null) {
      commit('setProducts', products)
      return products
    }
    return []
  },

  async getAllExpired({ commit }, params) {
    const products = await Api.Product.getAllExpired(params)
    if (products !== null) {
      commit('setProductsExpired', products)
      return products
    }
    return []
  },

  async getBasicList(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    let products = await Api.Product.getBasicList(params)
    if (products !== null) {
      return products
    }
  },

  async getBasicListByLaboratory(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    let products = await Api.Product.getBasicListByLaboratory(params)
    if (products !== null) {
      return products
    }
  },

  async getById(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const Product = await Api.Product.getById(params)
    if (Product !== null) {
      return Product
    }
    return null
  },

  async deleteById(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Product.deleteById(params)
    return result
  },

  async deleteProductById(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    id
  ) {
    const result = await Api.Product.deleteProductById(id)
    return result
  },

  async deleteAll(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Product.deleteAll(params)
    return result
  },

  async deleteProductsByLab(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    { labId, force = false }
  ) {
    const result = await Api.Product.deleteProductsByLab(labId, force)
    return result
  },

  async save(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    Product
  ) {
    const result = await Api.Product.save(Product)
    return result
  },

  async sendEmailsExpired(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    Product
  ) {
    const result = await Api.Product.sendEmailsExpired(Product)
    return result
  },

  async import(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    Product
  ) {
    const result = await Api.Product.import(Product)
    return result
  },
}

const mutations = {
  setProducts(state, products) {
    state.all = products.items
  },
  setProductsExpired(state, products) {
    state.expired = products.items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
